
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/applications",
      function () {
        return require("private-next-pages/admin/applications/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/applications"])
      });
    }
  